import React from 'react'


const LabelDetailHtml = props => {
    const { title, description } = props
    
    return (
        <div className='label-detail'>
            <p className='title'>{title}</p>
            <p dangerouslySetInnerHTML={{ __html: description }} className='description'></p>
        </div>
    )
}

export default LabelDetailHtml


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Label/LabelDetailHtml.js